import { ToastButton } from "@ionic/vue";
import Translator from "@/plugins/Translator";
import { ToastRoles } from "@/models/ToastButtons/ToastRoles";

const translator = Translator.getInstance();
const i18n = translator.getI18nGlobalInstance();

/**
 * UI Button um eine Aktion abzubrechen
 */
export const DismissButton: ToastButton = {
	role: ToastRoles.DISMISS,
	text: i18n.t("actions.dismiss"),
};
